import { API, Auth } from 'aws-amplify'

const POST_NEW_ONBOARD_REQUEST = async function(data) {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech'
  let myInit = {
    body: {
      data: data
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_NEW_ONBOARD_INVITE_REQUEST = async function(data) {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech-direct-invite'
  let myInit = {
    body: {
      data: data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_ONBOARD_REQUEST_SIGNUP = async function(data) {
  let apiName = 'ecobanka'
  let path = '/users/neofintech-signup'
  let myInit = {
    body: {
      data: data
    }
  }
  return await API.post(apiName, path, myInit)
}

const PUT_UPDATE_ONBOARD_REQUEST = async function(data) {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech/' + data.requestId
  let myInit = {
    body: {
      data: data.data
    }
  }
  return await API.put(apiName, path, myInit)
}

const PUT_REASSIGN_ONBOARD_REQUEST = async function(data) {
  let apiName = 'ecobanka'
  let path = `/requests/neofintech/${data.requestId}/reassign`
  let myInit = {
    body: {
      data
    }
  }
  return await API.put(apiName, path, myInit)
}

const PUT_UPDATE_ONBOARD_REQUEST_INFO = async function(data) {
  let apiName = 'ecobanka'
  let path = `/requests/neofintech/${data.requestId}/info`
  let myInit = {
    body: {
      data: data.data
    }
  }
  return await API.put(apiName, path, myInit)
}

const DELETE_ONBOARD_REQUEST_MESSAGE = async function(payload) {
  let apiName = 'ecobanka'
  let path = `/requests/neofintech/${payload.requestId}/messages/${payload.messageId}`
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.del(apiName, path, myInit)
}

const DELETE_ONBOARD_REQUEST_FILE = async function(payload) {
  let apiName = 'ecobanka'
  let path = `/requests/neofintech/${payload.requestId}/files/${payload.fileId}`
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.del(apiName, path, myInit)
}

const POST_NEW_ONBOARD_REQUEST_MESSAGE = async function(data) {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech/' + data.requestId + '/new-message'
  let myInit = {
    body: {
      data: data.data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_NEW_ONBOARD_REVIEW_REQUEST = async function(data) {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech/' + data.requestId + '/new-review-request'
  let myInit = {
    body: {
      data: data.data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_SEND_REQUEST_INVOICE = async function(data) {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech/' + data.requestId + '/send-invoice'
  let myInit = {
    body: {
      data: data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_RESPOND_ONBOARD_REVIEW_REQUEST = async function(data) {
  let apiName = 'ecobanka'
  let path =
    '/requests/neofintech/' + data.requestId + '/respond-review-request'
  let myInit = {
    body: {
      data: data.data
    },
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_SIGN_UP_ONBOARD_REQUEST_PHASE_3 = async function(data) {
  let apiName = 'ecobanka'
  let path = '/requests/' + data.requestId + '/phase3/sign-up'
  let myInit = {
    body: {
      data: data
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_REQUEST_NDA_SIGNATURE = async function(data) {
  let apiName = 'ecobanka'
  let path = '/sign-nda'
  let myInit = {
    body: {
      data: data
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_REQUEST_CONTRACT_SIGNATURE = async function(data) {
  let apiName = 'ecobanka'
  let path = '/sign-contract'
  let myInit = {
    body: {
      data: data
    }
  }
  return await API.post(apiName, path, myInit)
}

const POST_REQUEST_PAYMENT = async function(data) {
  let apiName = 'ecobanka'
  let path = '/payments'
  let myInit = {
    body: {
      data: data
    }
  }
  return await API.post(apiName, path, myInit)
}

const DELETE_ONBOARD_REQUEST = async function(requestId) {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech/' + requestId
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.del(apiName, path, myInit)
}

const GET_REQUEST_SHARED_DOCS = async function(requestId, token) {
  let apiName = 'ecobanka'
  let path = `/shared-docs/${requestId}?token=${token}`
  let myInit = {
    headers: {}
  }
  return await API.get(apiName, path, myInit)
}

const GET_ONBOARD_REQUEST_INFO = async function(requestId) {
  let apiName = 'ecobanka'
  let path = `/requests/neofintech/${requestId}/info`
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.get(apiName, path, myInit)
}

const GET_ONBOARD_REQUEST_FILES = async function(requestId) {
  let apiName = 'ecobanka'
  let path = `/requests/neofintech/${requestId}/files`
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.get(apiName, path, myInit)
}

const GET_ONBOARD_DETAILS = async function(requestId) {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech/' + requestId
  return await API.get(apiName, path)
}

const GET_ONBOARD_TIMELINE_EVENTS = async function(requestId) {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech/' + requestId + '/timeline-events'
  return await API.get(apiName, path)
}

const GET_ONBOARD_REQUESTS = async function() {
  let apiName = 'ecobanka'
  let path = '/requests/neofintech/'
  let myInit = {
    headers: {
      Authorization: (await Auth.currentSession()).idToken.jwtToken
    }
  }
  return await API.get(apiName, path, myInit)
}

export {
  POST_NEW_ONBOARD_REQUEST,
  POST_NEW_ONBOARD_INVITE_REQUEST,
  GET_ONBOARD_DETAILS,
  GET_ONBOARD_TIMELINE_EVENTS,
  GET_ONBOARD_REQUESTS,
  PUT_UPDATE_ONBOARD_REQUEST,
  PUT_UPDATE_ONBOARD_REQUEST_INFO,
  PUT_REASSIGN_ONBOARD_REQUEST,
  GET_ONBOARD_REQUEST_INFO,
  GET_ONBOARD_REQUEST_FILES,
  POST_REQUEST_PAYMENT,
  POST_SEND_REQUEST_INVOICE,
  POST_REQUEST_NDA_SIGNATURE,
  POST_REQUEST_CONTRACT_SIGNATURE,
  POST_SIGN_UP_ONBOARD_REQUEST_PHASE_3,
  POST_ONBOARD_REQUEST_SIGNUP,
  POST_NEW_ONBOARD_REQUEST_MESSAGE,
  POST_NEW_ONBOARD_REVIEW_REQUEST,
  POST_RESPOND_ONBOARD_REVIEW_REQUEST,
  DELETE_ONBOARD_REQUEST,
  DELETE_ONBOARD_REQUEST_MESSAGE,
  GET_REQUEST_SHARED_DOCS,
  DELETE_ONBOARD_REQUEST_FILE
}
